import { useEffect } from 'react'

import axios from '@/utils/assessmentAxiosInterceptor'

export const loadInitial = (dispatch) => {
    useEffect(() => {
        let fallbackRedirect = '/login'

        if ((window.location.pathname && window.location.pathname !== '/') || window.location.search) {
            fallbackRedirect += '?redirect=' + encodeURIComponent(window.location.pathname + window.location.search)
        }
        const getData = async () => {
            try {
                // Send a request to the server to pass back information regarding this current case
                let { data: body } = await axios.get(`/assessment/api/dashboard/loadInitialDashboard`)

                if (!body.success) {
                    window.location = fallbackRedirect
                    return
                }

                dispatch({ type: 'SET_USER', payload: body.data.user })
                dispatch({ type: 'SET_COMPANIES', payload: body.data.companies })
                dispatch({ type: 'SET_PARTNERSHIPS', payload: body.data.partnerships })
                dispatch({ type: 'SET_LOADED' })
            } catch (e) {
                if (e?.response?.status === 401) {
                    window.location = fallbackRedirect
                    return
                }
                console.log(e)
                return
            }
        }

        getData()
    }, [])
}
